import PopupFinalPDFData from './PopupFinalPDFData';

export default PopupFinalPDFData;